import { Box, Container, Heading } from "@chakra-ui/react";

const TermsPage = () => {
  return (
    <main>
      <Container maxW="container.xl" mb="36px" layerStyle="blog_post_body">
        <Box textAlign="center" my="24px">
          <Heading as="h1" color="brand.secondary" mb="12px">
            Terms of Use
          </Heading>
          <Heading as="h4" color="brand.primary" size="md">
            Last Updated 11/08/2024
          </Heading>
        </Box>
        <p>
          <strong>1. SCOPE OF AGREEMENT</strong>
        </p>
        <p>
          PLEASE READ THE FOLLOWING TERMS OF USE CAREFULLY BEFORE USING THE
          MINDSET CARE WEBSITE.
        </p>
        <p>
          This Terms of Use Agreement (&quot;<strong>Agreement</strong>&quot;)
          by and between Mindset Care Inc. (&quot;<strong>we</strong>&quot;,
          &quot;<strong>us</strong>&quot;, &quot;<strong>our</strong>&quot; or
          &quot;<strong>Mindset Care</strong>&quot;) and you (&quot;
          <strong>you</strong>&quot; or &quot;<strong>your</strong>&quot;)
          governs our relationship with you as a user of the{" "}
          <a href="https://mindset.care/smsterms">
            <strong>mindset.care</strong>
          </a>{" "}
          website as well as any other media form, media channel, mobile website
          or mobile application related, linked or otherwise connected to
          Mindset Care owned or controlled websites (collectively, &quot;
          <strong>Sites</strong>&quot;) together with all information, content,
          products, materials and services made available to you through the
          same by us and/or third parties (which together with the Site shall be
          collectively referred to as the &quot;<strong>Services</strong>
          &quot;).
        </p>
        <p>
          By using or otherwise accessing the Services, or any component
          thereof, in any manner whatsoever, you agree to be bound by and comply
          with the terms and conditions of this Agreement and acknowledge that
          you have read our Privacy Policy at{" "}
          <a href="https://mindset.care/privacy">
            <strong>mindset.care/privacy</strong>
          </a>{" "}
          .
        </p>
        <p>
          By providing your email address or mobile telephone number, you agree
          that we may communicate with you via text messages or other electronic
          means to your mobile device, provided that we obtain your consent
          where we are legally required to do so. In the event you change or
          deactivate your email address or mobile telephone number, you agree to
          promptly update your Mindset Care account information to ensure that
          your messages are not sent to the wrong person. You can opt out of
          certain types of communications via your account settings.
        </p>
        <p>
          When we refer to the &quot;use&quot; of the Services in this
          Agreement, we mean any actual or attempted access or use of the
          Services, including, without limitation, any transmission, exchange of
          information or communication associated with the Services. These terms
          and conditions, together with any other terms of use applicable to
          other Sites, as specifically noted on such sites, and any other
          policies, rules and provisions which are described, linked or
          otherwise referred to and form a part of this Agreement, including,
          without limitation our Privacy Policy, and our SMS/MMS Mobile Message
          Marketing Program Terms and Conditions and Privacy Policy at
          constitute the entire agreement between you and us, superseding any
          and all prior or inconsistent understandings, representations or
          agreements regarding the Services. Supplemental terms and conditions
          or documents that may be posted on the Site from time to time are
          hereby expressly incorporated here by reference. IF YOU DO NOT AGREE
          WITH ALL OF THESE TERMS OF USE, THEN YOU ARE EXPRESSLY PROHIBITED FROM
          ACCESSING OR USING THE SITE IN ANY MANNER AND YOU MUST DISCONTINUE USE
          IMMEDIATELY. IF YOU CONTINUE TO USE THE SITE, THAT ACTION CONSTITUTES
          AN UNRESERVED ACCEPTANCE OF THE TERMS OF USE.
        </p>
        <p>
          We reserve the right at any time and from time to time in our sole
          discretion to modify or discontinue, temporarily or permanently, the
          Services (or any part of it) with or without notice. In the event of a
          modification or discontinuance, all information submitted by you may
          be lost. You agree to keep a permanent record of all information
          provided to us, and you agree that all information submitted to us is
          at your sole risk. You agree that we have no responsibility or
          liability for the deletion or failure to store any content maintained
          or transmitted by the Services including without limitation messages
          and other communications. You agree that we shall not be liable to you
          or to any third-party for any loss or corruption of any such data, and
          you hereby waive any right of action against us from any such loss or
          corruption of such data, and any modification, suspension or
          discontinuance of the Services. We may similarly change this Agreement
          at any time, and we will alert you about major changes or
          modifications by updating the “Last updated” date of this Agreement,
          or otherwise and you wave any right to receive specific notice of each
          such change. It is your responsibility to periodically review this
          Agreement to stay informed of updates. You will be subject to and will
          be deemed to have been made aware of, and to have accepted, the
          changes in any revised terms of use by your continued use of the Site
          after the date such revised terms of use are posted. If any new
          products or services become available, they will be considered a part
          of the Services and your use of them will be governed by the terms and
          conditions of this Agreement unless we notify you that different terms
          and conditions apply. You must also comply with any additional terms
          which apply to third-party content, material, information, software or
          other services. You agree that we may automatically upgrade our
          Services, and these terms will apply to all upgrades.
        </p>
        <p>
          <strong>2. PRIVACY POLICY</strong>
        </p>
        <p>
          We care about data privacy and security. Please review our Privacy
          Policy: <strong>[mindset.care/privacy.html]</strong>. By using the
          Site, you agree to be bound by our Privacy Policy, which is
          incorporated into this Agreement. The Site is hosted in the United
          States. If you access the Site from any other region of the world with
          laws or other requirements governing personal data collection, use, or
          disclosure that differ from applicable laws in the United States, then
          through your continued use of the Site, you are transferring your data
          to the United States. By using our Services or otherwise providing
          information to us, you consent to this transfer, processing, and
          storage of your data in the United States and acknowledge that this
          transfer, processing, and storage is necessary for the performance of
          the contract between you and Mindset Care and to provide you with our
          Services. The information provided on the Site is not intended for
          distribution to or used by any person or entity in any jurisdiction or
          country where such distribution or use would be contrary to law or
          regulation, or which would subject Mindset Care to any registration
          requirement within such jurisdiction or country. Accordingly, those
          persons or entities who choose to access the site from other locations
          do so on their own initiative and are solely responsible for
          compliance with local laws if and to the extent local laws are
          applicable.
        </p>
        <p>
          <strong>3. AGE RESTRICTION</strong>
        </p>
        <p>
          You may not use the Site or the Services if you are under eighteen
          (18) years of age. By using the Site, (a) you acknowledge and agree
          that you are not under the age of eighteen (18) years, or are of adult
          age in your jurisdiction, (b) that you are permitted by your
          jurisdiction’s applicable law to use the Site and the Services, and
          (c) you are fully able and competent to enter into the terms,
          conditions, obligations, affirmations, representations and warranties
          set forth in this Agreement and our Privacy Policy, and to abide by
          and comply with this Agreement, and all applicable laws. We assume no
          responsibility or liability for any misrepresentation of your age.
        </p>
        <p>
          <strong>4. INTELLECTUAL PROPERTY</strong>
        </p>
        <p>
          Unless otherwise indicated, the Site is our proprietary property and
          all source code, databases, functionality, software, website designs,
          audio, video, text, photographs, and graphics on the Site (together
          with any updates, modifications, or derivative works, collectively,
          the “<strong>Content</strong>”) and the trademarks, service marks, and
          logos contained therein (the “<strong>Marks</strong>”) are owned or
          controlled by us or licensed to us, and are protected by copyright and
          trademark laws and various other intellectual property rights and
          unfair competition laws of the United States, international copyright
          laws, and international conventions. The Content and the Marks are
          provided on the Site “AS IS” for your information and personal use
          only. Except as expressly provided in this Agreement, no part of the
          Site and no Content or Marks may be copied, reproduced, aggregated,
          republished, uploaded, posted, publicly displayed, encoded,
          translated, transmitted, distributed, sold, licensed, or otherwise
          exploited for any commercial purpose whatsoever, without our express
          prior written permission.
        </p>
        <p>
          Provided that you are eligible to use the Site, you are granted a
          limited, non-transferable, non-sublicensable license to access and use
          the Site and to download or print a copy of any portion of the Content
          to which you have properly gained access solely for your personal,
          non-commercial use. We reserve all rights not expressly granted to you
          in and to the Site, the Content and the Marks.
        </p>
        <p>
          Your license to access and use the Site is subject to the following
          restrictions and prohibitions on use. You may not (1) copy, print
          (except for the express limited purpose permitted herein), republish,
          display, transmit, distribute, sell, rent, lease, loan or otherwise
          make available in any form or by any means all or any portion of the
          Site or any information or materials retrieved therefrom; (2) use the
          content or any other materials from the Site to develop, or as a
          component of, an information storage and retrieval system, database,
          or similar information resource (in any media now existing or
          hereafter developed), that is offered for commercial distribution of
          any kind, including through sale, license, lease, rental,
          subscription, or any other commercial distribution mechanism; (3)
          create compilations or derivative works of the Site; (4) use the Site
          in any manner that may infringe any copyright, intellectual property
          right, proprietary right, or property right of Mindset Care or any
          third parties; (5) remove, change, or obscure any copyright notice or
          other proprietary notice or terms of use contained in the Site; (6)
          make any portion of the Site available through any timesharing system,
          service bureau, the Internet, or any other technology now existing or
          developed in the future; (7) remove, disable, defeat or change any
          functionality or appearance of the Site; (8) decompile, disassemble or
          reverse engineer any Site software or use any network monitoring or
          discovery software to determine the site architecture; (9) use any
          automatic or manual process to harvest information from the Site; (10)
          use the Site for the purpose of gathering information for or
          transmitting (a) unsolicited commercial email; (b) email that makes
          use of Mindset Care&#39;s name or trademarks, including in connection
          with invalid or forged headers, invalid or nonexistent domain names,
          or other means of deceptive addressing; and (c) unsolicited telephone
          calls or facsimile transmissions; (11) use the Site in a manner that
          violates any state or federal law regulating commercial email,
          facsimile transmissions or telephone solicitations; (12) export or
          re-export the Site or any portion thereof, or any software available
          on or through the Site, in violation of the export control laws and
          regulations of the United States; and (13) use the Site or its content
          in a manner that is not expressly permitted by this Agreement.
        </p>
        <p>
          You acknowledge and agree that any breach or threatened breach of this
          Section by you may cause irreparable damage to Mindset Care and shall
          entitle Mindset Care, in addition to any other remedies available to
          it under this Agreement, the right to seek injunctive or other
          equitable relief.
        </p>
        <p>
          <strong>5. COPYRIGHT COMPLAINTS</strong>
        </p>
        <p>
          Mindset Care respects the intellectual property rights of others.
          Mindset Care may, under appropriate circumstances and at its
          discretion, disable and/or terminate access to or use of the Services
          for those users who may be infringing the intellectual property rights
          of others. If you believe that your work has been copied in a manner
          that constitutes copyright infringement, please provide Mindset Care
          the information specified below. Please note that this procedure is
          exclusively for notifying Mindset Care that your copyrighted material
          has been infringed.
        </p>
        <p>
          An electronic or physical signature of the person authorized to act on
          behalf of the owner of the copyright interest;
        </p>
        <p>
          A description of the copyrighted work that you claim has been
          infringed upon;
        </p>
        <p>
          A description of where the material that you claim is infringing is
          located on the Site;
        </p>
        <p>Your address, telephone number, and email address;</p>
        <p>
          A statement by you that you have a good-faith belief that the disputed
          use is not authorized by the copyright owner, its agent, or the law;
        </p>
        <p>
          A statement by you, made under penalty of perjury, that the above
          information in your notice is accurate and that you are the copyright
          owner or authorized to act on the copyright owner&#39;s behalf.
        </p>
        <p>
          Mindset Care&#39;s copyright agent for notice of claims of copyright
          infringement can be reached by emailing our Customer Service Manager
          at allison@mindset.care.
        </p>
        <p>
          <strong>6. REGISTRATION INFORMATION AND PASSWORDS</strong>
        </p>
        <p>
          You may be required to provide us with certain information in order
          register and to obtain access to and use of certain features and
          functions of the Services including, without limitation, your name or
          your company&#39;s name, login credentials (e.g., your email address
          and password), address, telephone number(s), email address, and/or
          location (collectively, your &quot;<strong>Information</strong>
          &quot;).
        </p>
        <p>
          Certain features and functions of the Services are not generally
          available to the public. In order to access and use such features and
          functions, we may require you to enter your email and password. Third
          parties may also, from time to time, provide you with additional codes
          or passwords necessary to perform certain actions or otherwise access
          the Services. Your email, password, and any additional codes or
          passwords are collectively referred to herein as &quot;
          <strong>IDs</strong>&quot;. Your IDs are personal to you. You agree
          that you will not allow another person to use your IDs to access and
          use the Services under any circumstances and that you are responsible
          for all activities that occur on your account using your ID, even if
          you did not authorize such activities.
        </p>
        <p>
          You are solely responsible for maintaining the strict confidentiality
          of your IDs and for any charges, damages, liabilities, or losses
          incurred or suffered because of your failure to do so. We are not
          liable for any harm caused by or related to the theft of your IDs,
          your disclosure of your IDs, or your authorization to allow another
          person to access and use the Services using your IDs. You agree to
          immediately notify us if you become aware of any unauthorized use of
          your IDs or other need to deactivate an ID due to security concerns.
        </p>
        <p>
          <strong>
            7. ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES
          </strong>
        </p>
        <p>
          Visiting the Site, sending us emails, and completing online forms
          constitute electronic communications. You consent to receive
          electronic communications, and you agree that all agreements, notices,
          disclosures, and other communications we provide to you
          electronically, via email and on the Site, satisfy any legal
          requirement that such communication be in writing. YOU HEREBY AGREE TO
          THE USE OF ELECTRONIC SIGNATURES, CONTRACTS, ORDERS, AND OTHER
          RECORDS, AND TO ELECTRONIC DELIVERY OF NOTICES, POLICIES, AND RECORDS
          OF TRANSACTIONS INITIATED OR COMPLETED BY US OR VIA THE SITE. You
          hereby waive any rights or requirements under any statutes,
          regulations, rules, ordinances, or other laws in any jurisdiction
          which require an original signature or delivery or retention of
          non-electronic records, or to payments or the granting of credits by
          any means other than electronic means.
        </p>
        <p>
          <strong>8. USER REPRESENTATIONS</strong>
        </p>
        <p>
          By using the Site, you represent and warrant that: (1) all Information
          you submit will be true, accurate, current, and complete; (2) you will
          maintain the accuracy of such Information and promptly update such
          Information as necessary; (3) you have the legal capacity and you
          agree to comply with this Agreement; (4) you are eighteen (18) years
          of age or older; (5) you will not access the Site through automated or
          non-human means, whether through a bot, script, or otherwise, except
          for assistive technologies as may be required for accessibility; (6)
          you will not use the Site for any illegal or unauthorized purpose; (7)
          you will keep your ID confidential, and (8) your use of the Site will
          not violate any applicable law or regulation.
        </p>
        <p>
          If you provide any information that is untrue, inaccurate, not
          current, or incomplete, or violate any of the terms of this Agreement
          or the representations of this Section 8, we have the right to suspend
          or terminate your account and refuse any and all current or future use
          of the Site (or any portion thereof).You represent, warrant and
          covenant to us that any and all Information and any other information
          or data you provide to us, is and will be true, accurate and complete
          when given to us, that in providing such Information to us you will
          not knowingly omit or misrepresent any material facts or information.
          You further consent and authorize us to verify your Information as
          required for your use and access to the Services, as applicable.
        </p>
        <p>
          <strong>9. ACCESS TO AND USE OF THE SERVICES</strong>
        </p>
        <p>
          You may not impersonate any person or entity, or falsely state or
          otherwise misrepresent your affiliation with a person or entity or
          misidentify yourself (e.g., pretend to be a different person or from a
          different company or organization).
        </p>
        <p>
          You may not use or allow others to use, your IDs and/or the Services,
          directly or indirectly, nor upload, distribute, transmit, communicate,
          link to, publish or access any data, information or material through,
          using or otherwise in connection with the Services, that: (a) is
          libelous, defamatory, vulgar or obscene, pornographic, sexually
          offensive or explicit, harmful or harassing, threatening, hateful,
          racially, culturally, ethnically or otherwise objectionable or
          offensive, discriminatory or abusive; (b) violates any law or
          regulation or the rights of others; (c) causes duress, distress or
          discomfort to another or is likely to deter or discourage others from
          using the Services; and/or (d) infringes any intellectual property,
          privacy or proprietary rights or confidentiality obligations of
          others. You are solely responsible and liable for any such activity,
          behavior, use and conduct. We have no liability, and you bear the sole
          and exclusive risk associated with use of or reliance on the accuracy,
          quality, completeness, reliability or usefulness of any data,
          information or material in connection with your IDs.
        </p>
        <p>
          You also may not use, nor allow others to use, your IDs, the Services,
          directly or indirectly, to: (a) attempt to or actually disrupt, impair
          or interfere with, alter or modify the Services or any information,
          data or materials posted and/or displayed by us or anyone else; (b)
          act in a way that affects or reflects negatively on us, the Services,
          or anyone else; (c) collect or attempt to collect any information from
          others including, without limitation, personally identifiable
          information, without such party&#39;s prior consent. You agree to
          comply with all local, state, federal laws, statutes, rules and
          regulations, as well as any international treaties, which are
          applicable to your use of the Services.
        </p>
        <p>
          You understand that by using the Site, you may be exposed to content
          that is offensive, indecent or objectionable, including content that
          may have been posted by third parties without our consent or
          permission. Under no circumstances will we be liable in any way for
          any content, including, but not limited to, for any errors or
          omissions in any content, or for any loss or damage of any kind
          incurred because of the use of any content posted, emailed or
          otherwise transmitted by via the Site.
        </p>
        <p>
          You are prohibited from violating or attempting to violate the
          security of the Services, including, without limitation: (a) using any
          type of computer “worm,” “virus” or any other device that is intended
          or is likely to disrupt, overload, or otherwise impair the workings of
          any part of the Site; or (b) sending unsolicited e-mail or other
          information, including promotions or advertising. Violations of system
          or network security or this Agreement may result in civil or criminal
          liability. If you do engage in such conduct, the resulting damage will
          be hard to quantify as a dollar amount and thus you hereby agree to
          pay us liquidated damages in the amount of $50,000 for each day that
          the Site is damaged until the Site is completely repaired. This amount
          is derived by estimating the value of (1) the loss of goodwill caused
          by an inoperable website, (2) the time and money it will take to
          repair the Site and to address the concerns of visitors. This clause
          will not prohibit us from seeking additional compensation if your
          conduct injures us in a way not expressly contemplated herein. We have
          the right to investigate occurrences which may involve such violations
          and may involve, provide information to and cooperate with, law
          enforcement authorities in prosecuting users who are involved in such
          violations.
        </p>
        <p>
          You are permitted to use the Site to request assistance with a
          supplemental security income and/or a social security disability
          insurance claim (each, a “<strong>Permissible Use</strong>”). You are
          not permitted to use the Site for any other reason than a Permissible
          Use. Impermissible uses shall include, but are not limited to, (a)
          using the Site to order or solicit, hire, engage or otherwise work
          with the employees or otherwise work with the employees or affiliates
          of Mindset Care; (b) accessing the Site for the purpose of data mining
          or extracting content from the Site beyond your personal end use; (c)
          forging headers or otherwise manipulating identifiers in order to
          disguise the origin of any content transmitted through the Site; or
          (d) for any other purpose other than as described herein (each, an “
          <strong>Impermissible Use</strong>”). If you do engage in such
          conduct, the resulting damage will be hard to quantify as a dollar
          amount and thus you hereby agree to pay us liquidated damages in the
          amount of $15,000 for each Impermissible Use. You further agree that
          this liquidated damages clause reasonably approximates actual costs,
          losses and expenses which would be incurred by Mindset Care, due to
          any such Impermissible Use. This clause will not prohibit us from
          seeking additional compensation if your conduct injures us in a way
          not expressly contemplated herein.
        </p>
        <p>
          You understand and agree that all information, statistical data, text,
          graphics, messages or other materials, whether publicly posted or
          privately transmitted by you and other users of our Services, are the
          sole responsibility of the person from which such content originated.
          This means that you, and not we or us, are entirely responsible for
          the content posted via the Site and, as such, we do not guarantee the
          accuracy, integrity or quality of such content. You acknowledge that
          we may or may not pre-screen content, but that we and our designees
          shall have the right, but not the obligation, in our sole discretion
          to pre-screen, refuse, or move any content that is available through
          or on the Site. Without limiting the foregoing, we and our designees
          shall have the right, but not the obligation, to remove any content
          that violates this Agreement or we, in our sole discretion, otherwise
          deem objectionable, excessive in size or are in any way burdensome to
          our systems and otherwise manage the Site in a manner designed to
          protect our rights and property and to facilitate the proper
          functioning of the Site.
        </p>
        <p>
          <strong>10. THIRD-PARTY WEBSITE AND CONTENT</strong>
        </p>
        <p>
          The Services may provide (or you may be sent via the Site), or third
          parties may provide, links to other websites or resources (“
          <strong>Third-Party Websites</strong>”) as well as article,
          photographs, text, graphics, pictures, designs, music, sound, video,
          information, applications, software, and other content or items
          belonging to or originating from third parties (“
          <strong>Third-Party Content</strong>”). Such Third-Party Websites and
          Third-Party Content are not investigated monitored or checked for
          accuracy appropriateness or completeness by us and we do not endorse
          and are not responsible for any Third-Party Websites accessed through
          the Site or any Third-Party Content posted on, available through, or
          installed from the Site, including the content, accuracy,
          offensiveness, opinions, reliability, privacy practices, or other
          policies of or contained in the Third-Party Websites or the
          Third-Party Content. Because we have no control over such sites and
          resources, you acknowledge and agree that we are not responsible for
          the availability of such external sites or resources. If you decide to
          leave the Site and access the Third-Party Websites or to use or
          install any Third-Party Content, you do so at your own risk, and you
          should be aware these Terms of Use no longer govern. You should review
          the applicable terms and policies, including privacy and data
          gathering practices, of any website to which you navigate from the
          Site or relating to any applications you use or install from the Site.
          Any purchases you make through Third-Party Websites will be through
          other websites and from other companies, and we take no responsibility
          whatsoever in relation to such purchases which are exclusively between
          you and the applicable third party. You agree and acknowledge that we
          do not endorse the products or services offered on Third-Party
          Websites and you shall hold us harmless from any harm caused by your
          purchase of such products or services. Additionally, you further
          acknowledge and agree that we shall not be responsible or liable,
          directly or indirectly, for any damage or loss caused or alleged to be
          caused by or in connection with use of or reliance on any such
          content, goods or services made available on or through any such site
          or resource.
        </p>
        <p>
          <strong>11. DISCLAIMER OF WARRANTY</strong>
        </p>
        <p>
          THE SITE IS PROVIDED ON AN AS-IS AND AS-AVAILABLE BASIS. YOU AGREE
          THAT YOUR USE OF THE SITE AND OUR SERVICES WILL BE AT YOUR SOLE RISK.
          TO THE FULLEST EXTENT PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES,
          EXPRESS OR IMPLIED, IN CONNECTION WITH THE SITE AND YOUR USE THEREOF,
          INCLUDING, WITHOUT LIMITATION, THE IMPLIED WARRANTIES OF
          MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND
          NON-INFRINGEMENT. WE MAKE NO WARRANTIES OR REPRESENTATIONS ABOUT THE
          ACCURACY OR COMPLETENESS OF THE SITE’S CONTENT OR THE CONTENT OF ANY
          WEBSITES LINKED TO THE SITE AND WE WILL ASSUME NO LIABILITY OR
          RESPONSIBILITY FOR ANY (1) ERRORS, MISTAKES, OR INACCURACIES OF
          CONTENT AND MATERIALS, (2) PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY
          NATURE WHATSOEVER, RESULTING FROM YOUR ACCESS TO AND USE OF THE SITE,
          (3) ANY UNAUTHORIZED ACCESS TO OR USE OF OUR SECURE SERVERS AND/OR ANY
          AND ALL PERSONAL INFORMATION AND/OR FINANCIAL INFORMATION STORED
          THEREIN, (4) ANY INTERRUPTION OR CESSATION OF TRANSMISSION TO OR FROM
          THE SITE, (5) ANY BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE WHICH MAY
          BE TRANSMITTED TO OR THROUGH THE SITE BY ANY THIRD PARTY, AND/OR (6)
          ANY ERRORS OR OMISSIONS IN ANY CONTENT AND MATERIALS OR FOR ANY LOSS
          OR DAMAGE OF ANY KIND INCURRED AS A RESULT OF THE USE OF ANY CONTENT
          POSTED, TRANSMITTED, OR OTHERWISE MADE AVAILABLE VIA THE SITE. WE DO
          NOT WARRANT, ENDORSE, GUARANTEE, OR ASSUME RESPONSIBILITY FOR ANY
          PRODUCT OR SERVICE ADVERTISED OR OFFERED BY A THIRD PARTY THROUGH THE
          SITE, ANY HYPERLINKED WEBSITE, OR ANY WEBSITE OR MOBILE APPLICATION
          FEATURED IN ANY BANNER OR OTHER ADVERTISING, AND WE WILL NOT BE A
          PARTY TO OR IN ANY WAY BE RESPONSIBLE FOR MONITORING ANY TRANSACTION
          BETWEEN YOU AND ANY THIRD-PARTY PROVIDERS OF PRODUCTS OR SERVICES. AS
          WITH THE PURCHASE OF A PRODUCT OR SERVICE THROUGH ANY MEDIUM OR IN ANY
          ENVIRONMENT, YOU SHOULD USE YOUR BEST JUDGMENT AND EXERCISE CAUTION
          WHERE APPROPRIATE.
        </p>
        <p>
          <strong>12. LIMITATION OF LIABILITY AND RELEASE</strong>
        </p>
        <p>
          TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, NEITHER MINDSET
          CARE, ITS LICENSORS, SUPPLIERS, PARTNERS, AFFILIATES OR THIRD-PARTY
          SERVICE PROVIDERS SHALL BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY
          DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, PUNITIVE OR
          CONSEQUENTIAL DAMAGES, OR ANY OTHER FORM OF DAMAGES IN ANY MANNER
          ARISING OUT OF OR IN CONNECTION WITH THIS AGREEMENT OR YOUR USE OF THE
          MINDSET CARE WEBSITES AND SERVICES, REGARDLESS OF THE FORM OF ACTION
          OR THE BASIS OF THE CLAIM OR WHETHER OR NOT MINDSET CARE HAS BEEN
          ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. SOME JURISDICTIONS DO NOT
          ALLOW THE LIMITATION OR EXCLUSION OF LIABILITY FOR INCIDENTAL OR
          CONSEQUENTIAL DAMAGES. NOTWITHSTANDING ANYTHING TO THE CONTRARY
          CONTAINED HEREIN, OUR LIABILITY TO YOU FOR ANY CAUSE WHATSOEVER AND
          REGARDLESS OF THE FORM OF THE ACTION, WILL AT ALL TIMES BE LIMITED TO
          THE LESSER OF THE AMOUNT PAID, IF ANY, BY YOU TO US DURING THE SIX (6)
          MONTH PERIOD PRIOR TO ANY CAUSE OF ACTION ARISING OR $100.00 USD.
          CERTAIN US STATE LAWS AND INTERNATIONAL LAWS DO NOT ALLOW LIMITATIONS
          ON IMPLIED WARRANTIES OR THE EXCLUSION OR LIMITATION OF CERTAIN
          DAMAGES. IF THESE LAWS APPLY TO YOU, SOME OR ALL OF THE ABOVE
          DISCLAIMERS OR LIMITATIONS MAY NOT APPLY TO YOU, AND YOU MAY HAVE
          ADDITIONAL RIGHTS.
        </p>
        <p>
          IN THE EVENT YOU HAVE ANY DISPUTE WITH ONE OR MORE THIRD PARTIES AS A
          RESULT OF YOUR USE OF THE MATERIAL OR THE SERVICES, OR ARE IN ANY WAY
          DAMAGED AS A RESULT OF ANY THIRD PARTY IN CONNECTION THEREWITH, YOU
          HEREBY RELEASE AND COVENANT NOT TO SUE OR OTHERWISE MAKE A CLAIM,
          DEMAND OR FILE ANY LEGAL ACTION OR INSTITUTE ANY LEGAL OR REGULATORY
          PROCEEDINGS AGAINST US, OUR AFFILIATES, OFFICERS, DIRECTORS,
          EMPLOYEES, AGENTS, REPRESENTATIVES AND SUPPLIERS FROM, FOR ANY CLAIMS,
          ACTIONS, DEMANDS OR DAMAGES (WHETHER DIRECT, INDIRECT, SPECIAL,
          INCIDENTAL OR CONSEQUENTIAL), OF WHATEVER KIND OR NATURE, KNOWN OR
          UNKNOWN, SUSPECTED OR UNSUSPECTED, WHETHER FORESEEABLE OR NOT,
          DISCLOSED OR UNDISCLOSED.
        </p>
        <p>
          <strong>13. INDEMNIFICATION</strong>
        </p>
        <p>
          You agree to defend, indemnify and hold us harmless against any
          losses, expenses, costs or damages (including our reasonable
          attorneys&#39; fees, expert fees&#39; and other reasonable costs of
          litigation) arising from, incurred as a result of, or in any manner
          related to any claim or action based upon (a) your breach of the terms
          and conditions of this Agreement, (b) your use of the Site and
          Services, (c) any Breach of your representations and warranties set
          forth in this Agreement, (d) your violation of the rights of a third
          party, including but not limited to intellectual property rights, (e)
          any overt harmful act toward any other user of the Site with whom you
          connected via the Site, and/or (f) the use of the Services by any
          other person using your IDs. Notwithstanding the foregoing, we reserve
          the right, at your expense, to assume the exclusive defense and
          control of any matter for which you are required to indemnify us, and
          you agree to cooperate, at your expense, with our defense of such
          claims. We will use reasonable efforts to notify you of any such
          claim, action, or proceeding which is subject to this indemnification
          upon becoming aware of it. We may, if necessary, participate in the
          defense of any such claim or action and any negotiations for its
          settlement or compromise. No settlement which may adversely affect our
          rights or obligations shall be made without our prior written
          approval.
        </p>
        <p>
          <strong>14. US TRADE SANCTIONS COMPLIANCE</strong>
        </p>
        <p>
          Mindset Care must comply with international trade sanctions imposed by
          the U.S. government. These sanctions prohibit Mindset Care from
          providing certain products and services to individuals or
          organizations located in designated countries, or to a person or
          organization that is designated on a U.S. government-maintained list.
          For this reason, individuals who (1) are on any such list or who work
          for a company that is on such a list, or (2) are affiliated with, or
          are employed by organizations that are affiliated with, governments of
          those countries that are subject to sanctions, or (3) are residents of
          or are ordinarily residents of countries where U.S. sanctions prohibit
          Mindset Care from providing certain products or services, will not be
          able to take advantage of the prohibited products or services.
          Further, individuals in certain countries may be subject to additional
          screening and, in some cases, may be prohibited from using certain
          products and services because of such US government sanctions.
        </p>
        <p>
          Please note, however, that U.S. government sanctions laws change from
          time to time, and Mindset Care reserves the right to immediately
          implement any changes or additions to these restrictions as
          appropriate, including terminating or suspending the provision of
          Services who it believes, in its sole discretion, may cause it to
          violate these laws.
        </p>
        <p>
          <strong>15. TERM AND TERMINATION</strong>
        </p>
        <p>
          This Agreement shall remain in full force and effect while you use the
          Site. WITHOUT LIMITING ANY OTHER PROVISION OF THIS AGREEMENT, WE
          RESERVE THE RIGHT TO, IN OUR SOLE DISCRETION AND WITHOUT NOTICE OR
          LIABILITY, DENY ACCESS TO AND USE OF THE SITE (INCLUDING BLOCKING
          CERTAIN IP ADDRESSES), TO ANY PERSON FOR ANY REASON OR FOR NO REASON,
          INCLUDING WITHOUT LIMITATION FOR BREACH OF ANY REPRESENTATION,
          WARRANTY, OR COVENANT CONTAINED IN THIS AGREEMENT OR OF ANY APPLICABLE
          LAW OR REGULATION. WE MAY TERMINATE YOUR USE OR PARTICIPATION IN THE
          SITE OR DELETE YOUR ACCOUNT AND ANY CONTENT OR INFORMATION THAT YOU
          POSTED AT ANY TIME, WITHOUT WARNING, IN OUR SOLE DISCRETION.
        </p>
        <p>
          If we terminate or suspend your account for any reason, you are
          prohibited from registering and creating a new account under your
          name, a fake or borrowed name, or the name of any third party, even if
          you may be acting on behalf of the third party. In addition to
          terminating or suspending your account, we reserve the right to take
          appropriate legal action, including without limitation pursuing civil,
          criminal, and injunctive redress.
        </p>
        <p>
          We may terminate this Agreement, restrict, suspend, or terminate your
          access to and use of the Services immediately and without notice or
          liability, with or without cause, and it will not limit any other
          rights or remedies which are available to us. You may terminate this
          Agreement by providing us with written notice of your termination and
          ceasing to use or access the Services. Termination is your sole right
          and exclusive remedy if you are not satisfied with the Services. Upon
          the effective date of any such termination, your right to access and
          use the Services shall immediately cease.
        </p>
        <p>
          <strong>16. DISPUTES</strong>
        </p>
        <p>
          <strong>Informal Negotiations</strong>
        </p>
        <p>
          To expedite resolution and control the cost of any dispute,
          controversy, or claim related to these Terms of Use (each a &quot;
          <strong>Dispute</strong>&quot; and collectively, the “
          <strong>Disputes</strong>”) brought by either you or us (individually,
          a “<strong>Party</strong>” and collectively, the “
          <strong>Parties</strong>”), the Parties agree to first attempt to
          negotiate any Dispute (except those Disputes expressly provided below)
          informally for at least thirty (30) days before initiating
          arbitration. Such informal negotiations commence upon written notice
          from one Party to the other Party.
        </p>
        <p>
          <strong>Binding Arbitration</strong>
        </p>
        <p>
          If the Parties are unable to resolve a Dispute through informal
          negotiations, the Dispute (except those Disputes expressly excluded
          below) will be finally and exclusively resolved through binding
          arbitration. YOU UNDERSTAND THAT WITHOUT THIS PROVISION, YOU WOULD
          HAVE THE RIGHT TO SUE IN COURT AND HAVE A JURY TRIAL. The arbitration
          shall be commenced and conducted under the Commercial Arbitration
          Rules of the American Arbitration Association (&quot;
          <strong>AAA</strong>&quot;) and, where appropriate, the AAA’s
          Supplementary Procedures for Consumer Related Disputes (&quot;
          <strong>AAA Consumer Rules</strong>&quot;), both of which are
          available at the AAA website: www.adr.org. Your arbitration fees and
          your share of arbitrator compensation shall be governed by the AAA
          Consumer Rules and, where appropriate, limited by the AAA Consumer
          Rules. The arbitration may be conducted in person, through the
          submission of documents, by phone, or online. The arbitrator will make
          a decision in writing but need not provide a statement of reasons
          unless requested by either Party. The arbitrator must follow
          applicable law, and any award may be challenged if the arbitrator
          fails to do so. Except where otherwise required by the applicable AAA
          rules or applicable law, the arbitration will take place in
          Wilmington, Delaware. Except as otherwise provided herein, the Parties
          may litigate in court to compel arbitration, stay proceedings pending
          arbitration, or to confirm, modify, vacate, or enter judgment on the
          award entered by the arbitrator.
        </p>
        <p>
          If for any reason, a Dispute proceeds in court rather than
          arbitration, the Dispute shall be commenced or prosecuted in the state
          and federal courts located in Wilmington, Delaware, and the Parties
          hereby consent to, and waive all defenses of lack of personal
          jurisdiction, and forum non conveniens with respect to venue and
          jurisdiction in such state and federal courts. Application of the
          United Nations Convention on Contracts for the International Sale of
          Goods and the the Uniform Computer Information Transaction Act (UCITA)
          is excluded from these Terms of Use.
        </p>
        <p>
          In no event shall any Dispute brought by either Party related in any
          way to the Site be commenced more than one (1) years after the cause
          of action arose. If this provision is found to be illegal or
          unenforceable, then neither Party will elect to arbitrate any Dispute
          falling within that portion of this provision found to be illegal or
          unenforceable, and such Dispute shall be decided by a court of
          competent jurisdiction within the courts listed for jurisdiction
          above, and the Parties agree to submit to the personal jurisdiction of
          that court.
        </p>
        <p>
          <strong>Restrictions</strong>
        </p>
        <p>
          The Parties agree that any arbitration shall be limited to the Dispute
          between the Parties individually. To the full extent permitted by law,
          (a) no arbitration shall be joined with any other proceeding; (b)
          there is no right or authority for any Dispute to be arbitrated on a
          class-action basis or to utilize class action procedures; and (c)
          there is no right or authority for any Dispute to be brought in a
          purported representative capacity on behalf of the general public or
          any other persons.
        </p>
        <p>
          <strong>Exceptions to Informal Negotiations and Arbitration</strong>
        </p>
        <p>
          The Parties agree that the following Disputes are not subject to the
          above provisions concerning informal negotiations and binding
          arbitration: (a) any Disputes seeking to enforce or protect, or
          concerning the validity of, any of the intellectual property rights of
          a Party; (b) any Dispute related to, or arising from, allegations of
          theft, piracy, invasion of privacy, or unauthorized use; and (c) any
          claim for injunctive relief. If this provision is found to be illegal
          or unenforceable, then neither Party will elect to arbitrate any
          Dispute falling within that portion of this provision found to be
          illegal or unenforceable and such Dispute shall be decided by a court
          of competent jurisdiction within the courts listed for jurisdiction
          above, and the Parties agree to submit to the personal jurisdiction of
          that court.
        </p>
        <p>
          <strong>
            YOU AGREE THAT ANY DISPUTE RESOLUTION PROCEEDINGS WILL BE CONDUCTED
            ONLY ON AN INDIVIDUAL BASIS AND NOT IN A CLASS, CONSOLIDATED OR
            REPRESENTATIVE ACTION
          </strong>
          , EXCEPT WHERE PROHIBITED BY LAW OR DEEMED BY A COURT OF LAW TO BE
          AGAINST PUBLIC POLICY.
        </p>
        <p>
          Except as may be required by law, neither a Party nor the arbitrator
          may disclose the existence, content, or results of any arbitration
          without the prior written consent of both Parties, unless to protect
          or pursue a legal right. If for any reason a Dispute proceeds in court
          rather than in arbitration, the Parties hereby waive any right to a
          jury trial. This arbitration provision shall survive any cancellation
          or termination of your agreement to participate in any of our
          Services.
        </p>
        <p>
          <strong>17. MISCELLANEOUS</strong>
        </p>
        <p>
          This Agreement and your use of the Services will be interpreted under
          and governed by the substantive laws of the state of Delaware,
          excluding its conflicts-of-law rules. You agree that exclusive
          jurisdiction and venue of any dispute with Mindset Care or its
          licensors, or any of their respective affiliates, officers, directors,
          employees, contractors, agents, representatives or suppliers, arising
          out of or in any way relating to this Agreement shall reside in the
          federal and state courts sitting in Wilmington, Delaware. This
          Agreement may not be modified by anyone except in writing signed by an
          authorized officer of Mindset Care. No failure or delay in enforcing
          any provision, exercising any option or requiring performance, shall
          be construed to be a waiver of that or any other right in connection
          with this Agreement. You may not assign your rights under this
          Agreement without our prior written permission and any attempt by you
          to do so shall be void. You agree that regardless of any statute or
          law to the contrary, any claim or cause of action arising out of or
          related to use of the Services or this Agreement must be filed within
          one (1) year after such claim or cause of action arose or be forever
          barred. If any term of this Agreement is held invalid, illegal or
          unenforceable, the remaining portions shall not be affected. Any
          provision of this Agreement which by its nature must survive the
          termination of this Agreement in order to give effect to its meaning
          shall survive such termination.
        </p>
        <p>
          <strong>18. CONTACT US</strong>
        </p>
        <p>
          In order to resolve a complaint regarding the Site or to receive
          further information regarding use of the Site, please contact us by
          either:
        </p>
        <ul>
          <li>Calling us at: 888-502-3799;</li>
          <li>Emailing us at: allison@mindset.care; or</li>
          <li>
            Writing to us via mail to: Mindset Care, Attention: Website Customer
            Service, 80 Broad St Fl 5 Suite 1085, New York, NY 10004.
          </li>
        </ul>
      </Container>
    </main>
  );
};

export default TermsPage;
